import React, { useEffect, useMemo, useState } from 'react';
import { XApi } from '../../services.js';

/** Options are fetched only when opened, without income/sparkline payloads. */
export default function CallerFilter({ apiId, bounds, value, onChange, logs = [] }) {
  const [open, setOpen] = useState(false), [search, setSearch] = useState(''), [term, setTerm] = useState('');
  const [page, setPage] = useState({ key: '', cursor: null, previous: [] }), [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false), [error, setError] = useState(false), [retry, setRetry] = useState(0);
  useEffect(() => { const t = setTimeout(() => setTerm(search.trim()), 250); return () => clearTimeout(t); }, [search]);
  const key = JSON.stringify([apiId, bounds, term]);
  const currentPage = page.key === key ? page : { key, cursor: null, previous: [] };
  const cursor = currentPage.cursor;
  useEffect(() => { setPage({ key, cursor: null, previous: [] }); }, [key]);
  useEffect(() => {
    let cancelled = false, restarting = false;
    setResult(null); setError(false);
    if (!open || !bounds) { setLoading(false); return; }
    setLoading(true);
    XApi.providerDashboardService.callerPage({ apiId, ...bounds, view: 'options', search: term, cursor, limit: 50 })
      .catch(async e => {
        if (e?.status !== 409 || cancelled || !cursor) throw e;
        restarting = true;
        setPage({ key, cursor: null, previous: [] });
        return null;
      }).then(r => { if (!cancelled && !restarting) setResult(r); })
      .catch(() => { if (!cancelled) setError(true); })
      .finally(() => { if (!cancelled && !restarting) setLoading(false); });
    return () => { cancelled = true; };
  }, [open, key, cursor, retry]);
  const options = useMemo(() => {
    const values = new Map((result?.items || []).map(r => [r.callerRef, { id: r.callerRef, name: `${r.callerHandle} (${r.earningRecords} 条收益记录)` }]));
    for (const log of logs) if (log.callerRef && !values.has(log.callerRef) && (!term || String(log.callerHandle ?? '').toLowerCase().includes(term.toLowerCase()))) values.set(log.callerRef, { id: log.callerRef, name: log.callerHandle });
    if (value && !values.has(value)) values.set(value, { id: value, name: '已选调用方' });
    return [...values.values()];
  }, [result, logs, value, term]);
  return <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 6, alignItems: 'center' }}>
    <button className="btn btn-sm btn-ghost" type="button" aria-expanded={open} onClick={() => setOpen(!open)}>调用方筛选{value ? ' · 已选择' : ''}</button>
    {open && <>
      <input style={{ background: 'var(--bg-1)', color: 'var(--fg-1)', border: '1px solid var(--bd-1)', borderRadius: 6, padding: '5px 8px' }} aria-label="搜索调用方" placeholder="搜索调用方代号" value={search} onChange={e => setSearch(e.target.value)} />
      <select style={{ background: 'var(--bg-1)', color: 'var(--fg-1)', border: '1px solid var(--bd-1)', borderRadius: 6, padding: '5px 8px', maxWidth: 260 }} aria-label="调用方" value={value || ''} onChange={e => onChange(e.target.value || null)}>
        <option value="">全部</option>{options.map(o => <option key={o.id} value={o.id}>{o.name}</option>)}
      </select>
      {loading && <span role="status">加载调用方…</span>}
      {error && <span role="status">调用方筛选暂不可用 <button className="btn btn-sm btn-ghost" onClick={() => setRetry(n => n + 1)}>重试调用方</button></span>}
      {currentPage.previous.length > 0 && <button className="btn btn-sm btn-ghost" disabled={loading} onClick={() => setPage({ key, cursor: currentPage.previous.at(-1), previous: currentPage.previous.slice(0, -1) })}>上一批调用方</button>}
      {result?.nextCursor && <button className="btn btn-sm btn-ghost" disabled={loading} onClick={() => setPage({ key, cursor: result.nextCursor, previous: [...currentPage.previous, cursor] })}>下一批调用方</button>}
    </>}
  </div>;
}
